// ── Webfonts (self-hosted) ────────────────────────────────────────────────
// 2026-08-10: 在此之前 tailwind.config.js 雖然寫著 Inter / Noto Sans TC, 但**沒有
// 任何地方載入它們** → 全站一直是在用作業系統預設字體 (Windows=Segoe UI,
// macOS=PingFang), 跨機器長得不一樣。
//
// **自架而不是 Google Fonts CDN**: 投資人登入的入口不該對第三方發請求 (隱私 +
// 少一個外部單點故障), 同源也省掉一次 DNS+TLS 握手; Vite 會出 hash 檔名 + immutable
// 快取。 用 variable 版 (wght 軸) → 400/500/600 共用同一個檔, 不是三份。
// 用 wght.css 而非 index.css: 排除我們沒在用的斜體與 optical-size 軸。
// fontsource 預設 font-display: swap → 字型下載期間先用系統字顯示, 不會有空白期。
// Noto Sans TC 依 unicode-range 切成 105 個 subset, 瀏覽器只抓頁面真的用到的那幾個。
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/noto-sans-tc/wght.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { reloadOnceForStaleChunk } from './lib/chunk-reload.ts';
import './styles/index.css';

// 部署後舊分頁的 modulepreload 失敗 → Vite 發 vite:preloadError。 自動重整一次
// 抓新 bundle (見 chunk-reload.ts)。 runtime 動態 import 失敗則由 ErrorBoundary 接。
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  reloadOnceForStaleChunk();
});

// 2026-06-15: MSAL / Entra SSO 已脫鉤. internal portal 統一走自己的
// email + password + forgot/reset password 流程 (V158).
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
